import styles from './styles.module.scss';

import { Button } from 'ui-components/src/Button';
import { Text } from 'ui-components/src/Text';
import { queryString } from 'ui-components/src/queryString';

import img_fuzzbuzz from './fuzzbuzz.png';
import { useEffect, useState } from 'react';
import { IKlass } from '../../../endpoints/src/types/IKlass';
import { v2 } from '../../../endpoints/src/v2';
import { Dialog } from 'ui-components/src/Dialog';

const queryParams = queryString.parse(location.search);

export default () => {
  const [klass, setKlass] = useState<IKlass>();
  const [error, setError] = useState(false);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!queryParams.code) {
      window.location.href = process.env.PUBLIC_WEBSITE_URL;
    }

    fetch(v2.klassBySecretCode(queryParams.code as string), { headers: { 'Kodable-API-Token': process.env.PUBLIC_API_TOKEN } })
      .then(res => {
        if (res.status === 404) {
          setNotFound(true);
        } else {
          return res.json()
        }
      })
      .then((klass: IKlass) => setKlass(klass))
      .catch(() => setError(true))
  }, []);

  return <div className={styles.container}>
    <Dialog open={notFound} onClose={() => { window.location.href = process.env.PUBLIC_WEBSITE_URL }}>
      <div className={styles.notFoundDialog}>
        <Text.H3>We couldn't find that class</Text.H3>
        <Text.Paragraph>Check the link with your child's teacher.</Text.Paragraph>
        <Button
          href={process.env.PUBLIC_WEBSITE_URL}
        >
          Go home
        </Button>
      </div>
    </Dialog>
    <Dialog open={error} onClose={() => window.location.reload()}>
      <div className={styles.notFoundDialog}>
        <Text.H3>An error occurred</Text.H3>
        <Text.Paragraph>Please try again later.</Text.Paragraph>
        <Button
          href={process.env.PUBLIC_WEBSITE_URL}
        >
          Reload
        </Button>
      </div>
    </Dialog>
    <div className={styles.box}>
      <img src={img_fuzzbuzz} style={{ width: 150 }} />
      <div className={styles.classTitleColumn}>
        {!klass && <Text.H3>Loading...</Text.H3>}
        {klass && <>
          <Text.H3>
            {klass.klass_name}
          </Text.H3>
          <Button
            href={`${process.env.PUBLIC_WEBSITE_URL}/connect/select-child?class_code=${klass.klass_code}&class_name=${encodeURIComponent(klass.klass_name)}`}
          >Connect</Button>
        </>}
      </div>
    </div>
  </div>;
}